module.exports = __webpack_public_path__ + "static/media/link-icon.8cce1dcb.svg";